import InfographicImg from "public/complianceMngmnt/infographic.png";

export const FEATURES_CONSTANTS = {
  title: "Smarter Risk Response Starts with Visibility ",
  description:
    "OneMind empowers security teams with real-time intelligence, predictive analytics, and end-to-end visibility—so you can prioritize, patch, and prove security faster than ever. ",
  list: [
    {
      label: "Accelerated Time-to-Patch ",
      subLabel: "Fix Faster, Respond Smarter ",
      text: "OneMind dramatically reduces patch deployment time—by up to 70%—with automated pipelines that validate, prioritize, and apply fixes across your environment. Say goodbye to patch backlogs and hello to secure-by-default operations. ",
    },
    {
      label: "Full Asset Visibility",
      subLabel: "Know Every Exposure, Everywhere",
      text: "Whether it's cloud workloads, on-prem servers, containers, or IoT endpoints—OneMind ensures continuous visibility into all assets across your environment. No blind spots. No hidden risk.",
    },
    {
      label: "Exploit Prediction & Risk Intelligence",
      subLabel: "Stop Tomorrow’s Threats Today",
      text: "Backed by predictive intelligence from Tenable and AI analytics, OneMind surfaces which vulnerabilities are most likely to be exploited in the wild. Security teams can move from reactive patching to proactive threat prevention—before attackers strike.",
    },
    {
      label: "Real-Time Threat & Compliance Dashboard",
      subLabel: "One View. Total Control.",
      text: "Get centralized, real-time visibility into vulnerabilities, patch status, compliance posture, and threat exposure. OneMind’s unified dashboard empowers security teams to track KPIs, eliminate guesswork, and prove risk reduction to stakeholders.",
    },
  ],
  image: InfographicImg,
  maxW: "600px",
};
